import { render, staticRenderFns } from "./Apple.vue?vue&type=template&id=4d95355e&"
import script from "./Apple.vue?vue&type=script&lang=js&"
export * from "./Apple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports